import { BaseError } from './base';

type NetworkSwitchingUnavailableErrorParams = {
  extraMessages?: string[];
  originalError: unknown;
  walletProviderKey: string;
};

export class NetworkSwitchingUnavailableError extends BaseError {
  constructor({
    walletProviderKey,
    originalError,
    extraMessages,
  }: NetworkSwitchingUnavailableErrorParams) {
    const cause = originalError instanceof Error ? originalError : null;

    super({
      cause,
      code: 'network_switching_unavailable',
      docsUrl: null,
      metaMessages: [
        `Wallet provider key: ${walletProviderKey}`,
        ...(extraMessages ?? []),
      ],
      name: 'NetworkSwitchingUnavailableError',
      shortMessage: `Network switching is not available at this time. The user should manually switch networks in their wallet`,
    });
  }
}
